export default __webpack_public_path__ + "static/media/640_dummy2016-friseur01-mobile-de.9e6ddaf7.png";